import { AgentsCatalogue } from "@/components/agents/agents-catalogue.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/dashboard/agents/")({
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.agent_builder_title()) }],
	}),
});

function RouteComponent() {
	return <AgentsCatalogue />;
}
